import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import routesContract from './routesContract';
import LoadingIndicator from '../components/LoadingIndicator/LoadingIndicator';
import { ContractRoute } from '../pages/Contracts/ContractRoute';

const ContractRouter = (props) => {
  return (
    <Switch>
      {routesContract.map((route, index) => {
        return (
          <Route
            key={index}
            path={`${props.match.path}${route.path}`}
            exact={route.exact}
            render={() => (
              <Suspense fallback={<LoadingIndicator />}>
                <ContractRoute route={route} {...props} />
              </Suspense>
            )}
          />
        );
      })}
    </Switch>
  );
};

ContractRouter.propTypes = {
  match: PropTypes.object,
};

export default ContractRouter;
